<template>
	<div class="agreement">
		<div class="agreement-container">
			<div class="agreement-header">
				<i @click="closePage">×</i>
				<div class="title">入驻{{platFormName}}协议</div>
			</div>
			<div class="agreement-content">
				<p>甲方：天津市风行科技信息工程有限公司（以下简称甲方）</p>
				<p>乙方：入驻商家（以下简称乙方）</p>
				<p>根据《中华人民共和国合同法》、《产品质量法》、《食品安全法》及有关法律、法规的规定，甲乙双方本着自愿、平等、公平、诚实信用的原则，经友好协商，就甲方授权乙方在甲方电子商务平台{{platFormName}}进行产品销售及甲方为乙方提供电子商务交易服务的相关事宜，达成如下协议，以资双方共同遵守。</p>
				<p>一、合作模式</p>
				<p>1、甲方依照本协议规定为乙方开通店铺服务。乙方可通过甲方的{{platFormName}}电商平台网站（手机移动客户端）发布产品信息，与有意向购买乙方产品的甲方其他用户进行在线交流，订立买卖合同，为通过{{platFormName}}平台购买其产品的用户提供售后服务。</p>
				<p>2、乙方作为销售者，其店铺内产品均以乙方名义进行产品信息上传、展示、咨询答复、产品销售、一般贸易的发票开具、物流配送服务及提供售后服务等；乙方因产品销售及服务出现争议、纠纷或受到相关机构的调查时，由乙方以销售者身份自行处理。除本协议另有约定，{{platFormName}}不参与乙方商品的经营。</p>
				<p>二、入驻条件及证明文件提交</p>
				<p>（一）入驻条件</p>
				<p>乙方申请成为{{platFormName}}入驻商家，在{{platFormName}}开展经营活动，须持续满足以下条件：</p>
				<p>1、乙方资质齐全，是依据营业执照注册国的法律注册并领取合法有效的营业执照及其他经营许可，有固定经营地点，身份信息应为商家自身情况的客观表现；</p>
				<p>2、乙方同意本协议及{{platFormName}}平台的相关规则；</p>
				<p>3、乙方申请经营的产品来源合法，且保证所有产品符合《产品质量法》的相关具体要求，食品类产品符合《食品安全法》的相关具体要求；</p>
				<p>4、乙方按下文要求提交全部证明文件；</p>
				<p>5、乙方已按约定全额支付相关费用。</p>
				<p>（二）证明文件提交</p>
				<p>乙方根据本协议约定及{{platFormName}}平台相关规则向甲方提交证明文件或其他相关证明，包括但不限于合法有效的企业法人营业执照、卫生许可证、生产许可证等。</p>
				<p>（三）证明文件有效性保证</p>
				<p>1、乙方保证其向甲方提供的上述证明文件或其他相关证明真实、合法、准确、有效，所有文件在整个合同履行期间都处于有效期内。</p>
				<p>2、乙方所提交的上述文件如有任何变更或更新，应及时通知甲方。否则，因通知不及时或不通知造成乙方损失的，由乙方自行承担；若因此造成甲方损失的，乙方应予以赔偿。</p>
				<p>3、若上述文件的变更或更新导致乙方不符合本协议所规定入驻条件的，甲方有权单方全部或部分限制乙方经营，甚至终止本协议。</p>
				<p>4、若因乙方提交虚假、过期文件或未及时更新或通知证明文件导致的纠纷或被相关监管机关处罚的，由乙方独立承担全部法律责任；若因此造成甲方损失的，乙方应予赔偿。</p>
				<p>三、店铺服务的开通及停止</p>
				<p>（一）店铺服务的开通</p>
				<p>乙方满足入驻条件并向甲方提出入驻申请，经甲方审核通过，并于发出电子邮件入驻通知其注册成为{{platFormName}}平台用户后的7个工作日内为乙方开通拟开展经营的店铺服务，具体服务期以{{platFormName}}平台入驻系统显示为准。服务开通后，乙方可利用甲方平台用户名及自设密码登录商家后台，根据甲方规定流程上传店铺、发布产品信息、与用户交流达成交易，并使用本协议约定的其他有偿服务等。</p>
				<p>（二）店铺服务的停止</p>
				<p>1、乙方需要提前停止店铺服务的，应至少提前30个工作日向甲方提出书面申请，经甲方同意后由甲方停止该店铺的服务功能；为弥补甲方已投入的人力、物力和技术支持，乙方同意甲方不退还该店铺未到期部分相应的已缴纳费用。甲方停止乙方店铺的服务功能日起，乙方在使用期间产生的全部数据仅保留3个月，3个月后，甲方将删除乙方使用期间的全部数据，并不可恢复。</p>
				<p>2、出现以下任一情形时，甲方有权随时停止乙方该店铺的服务：</p>
				<p>（1）乙方不满足入驻条件的；</p>
				<p>（2）乙方提供虚假资料文件的；</p>
				<p>（3）乙方所经营的产品不符合约定的产品质量要求，或者涉嫌走私、假冒伪劣、旧货、返修品的；</p>
				<p>（4）未经甲方事先审核产品品牌而上传某品牌商品的；</p>
				<p>（5）其他违反本协议约定，或其他甲方认定侵犯甲方及其他消费者权益的。</p>
				<p>3、乙方未经甲方同意，擅自停止店铺经营，或者乙方因出现第（二）款第2项情形被甲方停止乙方该店铺服务的，视为违约。此时乙方已缴纳的相关费用未到期部分及相应保证金应用以冲抵违约金或由此给甲方造成损失的相应赔偿金，该金额不足以冲抵乙方应付违约金和赔偿金时，乙方应另行支付差额。在{{platFormName}}免费推广阶段，甲方则有权在乙方违反第（二）款第2项时单方面终止乙方使用{{platFormName}}的权利。</p>
				<p>四、双方的权利及义务</p>
				<p>（一）甲方的权利及义务</p>
				<p>1、甲方根据本协议向乙方提供电子商务交易平台及相应的技术支持服务，尽力维护{{platFormName}}的正常稳定运行，并努力提升和改进技术，对平台功能及服务进行更新、升级，不断提升平台性能和交易效率。</p>
				<p>2、甲方对乙方在使用{{platFormName}}平台过程中遇到的问题及提出的建议和意见积极予以回复，可依乙方需求对其使用{{platFormName}}平台提供合理的指导和培训。</p>
				<p>3、甲方有权要求乙方对{{platFormName}}指定商品提供进货凭证、出厂检验报告、第三方质检机构出具的检测报告等相关产品的质量合格证明文件。但是，甲方对乙方在{{platFormName}}平台上的交易行为及有关其它事项并无事先审查的义务。</p>
				<p>4、若甲方或第三方通知甲方，认为乙方可能有任何侵权、违法或违反本协议的情况，甲方有权根据本协议或有关法律、法规的规定对乙方采取相关执行行动，包括但不限于删除其在{{platFormName}}平台发布的任何信息内容、对乙方店铺实行服务功能限制或停止对乙方服务。</p>
				<p>5、甲方有权就乙方违法行为、侵犯他人合法权利或违反本协议约定的情况对乙方提起诉讼的权利。</p>
				<p>6、甲方有权要求乙方提供与乙方商品、售后服务等相关的信息，以便用户直接向{{platFormName}}平台的客服进行咨询；甲方有权要求乙方在指定期限内解决用户咨询或投诉，若未能解决，甲方有权对乙方采取相应处理措施。</p>
				<p>7、甲方对乙方因其店铺销售活动、产品质量或其他任何违法行为与任何第三人产生的争议纠纷或侵权行为均不承担任何责任。</p>
				<p>（二）乙方的权利及义务</p>
				<p>1、乙方同意{{platFormName}}根据乙方企业法人营业执照所载明的经营范围及乙方申请经营的经营类目核实及调整乙方在{{platFormName}}平台经营的具体商品各类、数量和类目范围。</p>
				<p>2、乙方同意由甲方或经甲方同意由其乙方聘请的甲乙双方同意的第三方对乙方提供的相关资料和信息进行审核，乙方应积极配合并承担由此产生的费用。甲方的审核为形式审核，乙方仍须对其提交资料的真实性、合法性和准确性承担相应的法律责任。如果乙方拒不承担相关费用，甲方有权从乙方未结算款项中扣除。</p>
				<p>3、乙方应确保其在{{platFormName}}提交的注册资料真实、准确、合法、有效，对获得的{{platFormName}}平台用户名（店铺用户名）妥善保管，不得转让或授权他人使用，并对利用该用户名和密码所进行的一切活动负全部责任。否则，乙方将承担由此带来的一切责任。</p>
				<p>4、为最大程度保护消费者权益，乙方有义务对其销售的每款商品按照相应法律标准、行业标准及甲方要求进行质量控制，包括但不限于对商品的合法性、安全性、描述真实性、标示标识、外观及包装进行控制。</p>
				<p>5、如因乙方商品、发布的信息或提供的售后服务问题而引发客户对甲方的诉讼或仲裁，甲方可披露乙方为实际商品的直接提供商，乙方应当承担由此产生的全部法律责任，如因此给甲方造成损失的，理应赔偿。</p>
				<p>6、乙方不得将从甲方获取的任何数据用于本协议约定以外的用途，同时保证未经甲方许可，不得擅自获取、使用、传播甲方的任何资料，包括但不限于交易数据、用户信息、支付信息、{{platFormName}}其他用户展示于{{platFormName}}平台的信息等。</p>
				<p>7、乙方不得在{{platFormName}}平台发布任何吸引{{platFormName}}用户到其他平台或乙方自身网络销售平台或渠道进行交易的任何信息，亦不得在其配送包裹中附带此类信息。</p>
				<p>8、乙方不得隐瞒任何可能对{{platFormName}}产生风险的事项，包括但不限于产品出现设计缺陷、质量瑕疵、权利纠纷、重大违约、上传资料包含病毒木马等，若乙方发生此类影响{{platFormName}}平台商誉、正常经营、安全的事项而乙方未及时通知甲方的，甲方有权解除本协议并追究乙方责任。</p>
				<p>9、乙方应保证其在平台上展示、销售的所有商品符合以下具体的产品质量要求：</p>
				<p>（1）产品的质量应符合下列要求：</p>
				<p>a、产品不存在危及人身、财产安全的危险，符合保障人体健康和人身、财产安全的相关法律标准、行业标准。</p>
				<p>b、具备产品应当具备的使用性能，对产品存在使用性能的瑕疵已作出说明。</p>
				<p>c、符合在产品或者其包装上注明采用的产品标准，符合以广告、产品说明、实物样品等方式表明的质量状况。</p>
				<p>（2）产品或者产品包装上的标识真实，并符合下列要求：</p>
				<p>a、限期使用的产品，在显著位置标明生产日期和安全使用期或失效日期。</p>
				<p>b、产品成分说明或配料表，其中应标明主要营养成分及其含量。</p>
				<p>c、使用不当，容易造成产品本身损坏或者可能危及人身、财产安全的产品，有警示标志。</p>
				<p>d、有关标识的其他适用要求。</p>
				<p>（3）乙方保证产品不存在以下欺诈行为：</p>
				<p>a、在商品中掺杂，掺假，以假充真，以次充好，或以不合格商品冒充合格商品。</p>
				<p>b、国家明令淘汰的商品或者失效，变质的商品。</p>
				<p>c、伪造商品的产地，伪造或者冒用他人的厂名，厂址，伪造或者冒用认证标志，名优标志等质量标志。</p>
				<p>d、商品应当检验、检疫而未检验、检疫或者伪造检验、检疫结果。</p>
				<p>（4）乙方发现其提供的产品存在严重缺陷，即使正确使用仍然可能对人身、财产安全造成危害的，保证立即告知甲方，并采取防止危害的措施，包括但不限于召回。</p>
				<p>（5）乙方向消费者提供有关商品或者服务的信息真实，没有引人误解的虚假宣传，没有发布虚假广告，欺骗和误导消费者，使购买商品或者接受服务的消费者的合法权益受到损害的行为。</p>
				<p>（6）乙方提供的食品符合卫生标准，提供的专供婴幼儿的主、辅食品符合营养、卫生标准，提供的食品添加剂、食品容器、包装材料和食品用工具、设备以及洗涤剂、消毒剂符合卫生标准和卫生管理办法规定。</p>
				<p>（7）乙方保证提供给甲方代销的商品均正牌产品，不存在假冒，没有侵犯他人专利权、著作权或者与著作权有关的权利或他人注册商标专用权或其他在先权利，来源合法、真实，不违反相关法律、法规的规定。</p>
				<p>（8）乙方提供的所有商品清洁、整齐、包装完好，适宜销售，送货时不得有任何包装破损或潮湿、变色。凡有保质期的商品如果保质期大于六个月的，乙方商品送达甲方指定收货地时其商品保质期距到期日的时限不得少于保质期规定的一半，否则甲方有权拒收；如果商品保质期小于六个月，则不应少于其保质期的三分之二，否则甲方有权拒收。</p>
				<p>（9）货品、吊牌及产品外包装上，不能有任何之前在其他商场或任何渠道销售的标志、价格。如乙方未对产品之前的价格标签或出现价格标签重叠、错粘及其他足以影响甲方商业信誉的任何标志及瑕疵进行处理，导致消费者对在平台售卖的商品存在任何负面性误解，造成甲方商业声誉受损或其他损害的，乙方应当为甲方消除影响并承担赔偿责任。如因此造成甲方对第三人承担任何法律责任，甲方承担责任后有权向乙方追偿。</p>
				<p>（10）乙方提供的产品不符合本协议约定的产品质量要求的，视为不合格货品，因乙方提供不合格产品，消费者有权将该货品退回乙方，运费由乙方承担，造成甲方或消费者任何损害（包括人身和财产损失），乙方应当承担赔偿责任。</p>
				<p>10、乙方应根据相关法律法规规定、本协议约定及甲方平台相关政策和承诺规定，负责为消费者提供产品的退货等系列售后服务，并承担因上述售后服务产生的一切费用，保障消费者权益，保证甲方免于承担因产品售后服务而产生的任何法律责任（包括任何赔偿或处罚）或声誉受损。</p>
				<p>五、保密条款</p>
				<p>1、甲乙双方在签订、履行本协议期间所获知的另一方的商业秘密负有保密义务。非经对方事先书面同意，任何一方不得向第三方泄露、给予或转让该保密信息。但法律、法规另有规定或协议另有约定的除外。</p>
				<p>2、如对方提出要求，任何一方均应将载有对方保密信息的任何文件、资料在本协议终止后按对方要求归还对方，或按对方要求予以销毁，或进行其他处置，并且不得继续使用该保密信息。</p>
				<p>3、在本协议终止之后，各方在本条款项下的义务并不随之终止，各方仍需遵守本协议之保密条款，履行其所承诺的保密义务。</p>
				<p>六、违约责任</p>
				<p>1、乙方向甲方提供虚假、失效的证明文件，在{{platFormName}}平台发布错误、虚假、违法及不良信息或作出其他违反本协议约定的行为，给甲方造成任何损失的（包括但不限于诉讼费、仲裁费、律师费、赔偿、补偿、行政机关处罚、差旅费等），乙方同意甲方自乙方缴纳的保证金及未结算款项中直接予以扣除，若前述金额不足以支付的，乙方应另行支付差额。在{{platFormName}}免费推广阶段，甲方则有权在在此情况下单方面终止乙方使用{{platFormName}}的权利。本协议另有约定的除外。</p>
				<p>2、乙方承诺不在甲方平台销售假冒伪劣产品，否则甲方有权要求乙方支付所涉商品在甲方平台销售额的10倍违约金，同时甲方有权对乙方采取暂停向乙方提供服务、暂时关闭乙方后台管理账户、暂缓支付未结算款项、终止合同等措施。</p>
				<p>3、若因乙方原因，致使甲方对其客户的赔偿、补偿、行政部门的处罚、律师费、诉讼费、仲裁费、鉴定费和差旅费等，乙方应全部赔偿。</p>
				<p>4、若协议任何一方违反本协议，因此对守约方造成任何损害、损失的，守约方有权按照本协议规定要求违约方承担违约责任，情节严重的，守约方可单方解除本协议并要求其承担相应损失。</p>
				<p>七、责任限制及免责</p>
				<p>1、在任何情况下，甲方均不对由于电力、网络、电脑、通讯或其他系统的故障、罢工、劳动争议、暴乱、火灾、洪水、风暴、爆炸、战争、政府行为等不可抗力，法院命令或第三方的不作为而造成的不能复位或延迟服务承担责任。</p>
				<p>2、甲方在此声明其对本协议项下的服务不做任何明示或暗示的保证，包含但不限于对服务的可适用性、没有错误或疏漏、持续性、准确性和可靠性、适用于某一特定用途。</p>
				<p>3、甲方仅为向乙方进行网上交易活动提供交易平台的服务提供商，并非乙方与{{platFormName}}其他用户进行交易活动的参与方，甲方不对乙方及参与交易的{{platFormName}}其他用户之间的交易行为引起的任何法律纠纷，包括但不限于投诉、起诉、举报及税赋等，均由参与交易的双方解决，与甲方无关。</p>
				<p>4、如本协议履行期间，甲乙双方任何一方遭受不可抗力，均应在遭受不可抗力后尽快通知对方，并于通知之日起15日内提供相关证明文件，不可抗力持续达到30日的，任何一方有权通知对方提前终止本协议。因不可抗力原因而导致本协议中止或终止的，双方均不须向对方承担违约责任。</p>
				<p>八、协议的变更、终止及解除</p>
				<p>1、任何一方对本协议条款进行变更或增加新的条款的，需提前5日通知对方其变更请求，由双方协商同意并签署补充协议予以确认。补充协议一经签署，即构成本协议的组成部分，与本协议具有同等法律效力。</p>
				<p>2、除本协议另有约定外，缔约双方中任何一方在本协议有效期内提前终止本协议的，须提前15日以书面形式通知对方，经对方同意后双方签署书面补充协议后，终止本协议。</p>
				<p>3、本协议终止，双方不再依据本协议约定开展新的业务合作，但并不影保密条款、责任承担条款、争议解决条款等条款的法律效力，相关权利义务双方仍应继续承担并切实履行。</p>
				<p>4、自本协议终止之日起30日内，甲乙双方进行退场清算，包括但不限于财务及在途货物的处理。在途货物指双方合作终止前，用户已经购买但尚未交付的商品，对于此类商品，乙方仍应按照合作终止前的流程交付并结算。</p>
				<p>5、本协议终止，并不免除乙方依据本协议应向客户承担的售后服务及产品保证责任，乙方仍应按照双方约定的售后服务履行售后义务及产品质量保证责任；如甲乙双方合作终止后，因乙方商品质量问题或售后服务问题而导致甲方或其他第三方人身或财产损失的，乙方仍应独立承担全部责任。</p>
				<p>九、法律适用及争议解决</p>
				<p>1、本协议的签订、解释、变更、履行及争议的解决等均适用中华人民共和国大陆地区现行法律。</p>
				<p>2、履行本协议过程中产生的任何争议，双方应协议解决，协商不成的，任何一方均可将争议提交重庆仲裁委员会，按照该会的仲裁规则进行仲裁。仲裁是终局的，仲裁裁决对协议双方具有最终的法律约束力。仲裁过程中，协议双方应尽可能得继续履行本协议除争议事项外的其余部分事项。仲裁费用应由败诉方承担，在仲裁期间，除仲裁部分之外的其他合同条款应当继续履行。</p>
				<p>十、其他</p>
				<p>1、本协议的任何一方未能及时行使本协议项下的权利不应被视为放弃该权利，也不影响该方在将来行使该权利。</p>
				<p>2、如果本协议中的任何条款无论因何种原因完全或部分无效、不具有执行力、或违反任何适用的法律，则该条款或该部分被视为删除。但本协议的其余条款仍应有效并且有约束力。</p>
				<p>3、本协议是缔约双方之间关于本协议中提及合作事项的完整的、唯一的协议，本协议取代了任何先前的关于该合作事项的协议和沟通（包括数据电文形式、书面形式和口头形式）。</p>
				<p>4、甲乙双方在签署本协议后，乙方可在完成电商入驻进入{{platFormName}}电商平台后自愿选择与甲方另行签订（或不签订）线下展销合作协议，与甲方进行线下合作，具体合作协议详见附件2。但本协议仍为主协议，其余附件2中未提及事项皆以本协议约定执行。</p>
				<p>5、本协议通过入驻时电子签署，视同于甲乙双方已认可本协议。如需纸质版，可进行打印盖章，纸质版与电子版具有同等法律效力。</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'agreement',
	data () {
		return {
			registerInfo: {}
		}
	},
	computed: {
		...mapState({
			platFormName: state => state.platFormStore.platFormName
		})
	},
	created () {
		if (this.$route.query) {
			this.registerInfo = this.$route.query
		}
	},
	methods: {
		closePage () {
			this.$router.push({ path: '/login', query: this.registerInfo })
		}
	}
}
</script>
<style lang="stylus" scoped>
.agreement {
	width: 100%
	height: 100%
	background-image url('~images/img/login-bg.jpg')
	background-repeat: no-repeat
	background-position: center
	background-size: cover
	.agreement-container {
		position relative
		top: 50%
		left: 50%
		transform translate(-50%, -50%)
		width 900px
		height 600px
		background: linear-gradient(to right, #fff , #dcdcde)
		.agreement-header {
			position relative
			height 50px
			i {
				position absolute
				top: 10px
				right: 20px
				font-size 30px
				cursor pointer
			}
			.title {
				font-size 24px
				text-align center
				line-height 50px
			}
		}
		.agreement-content {
			height: 550px
			overflow-x hidden
			overflow-y scroll
			p {
				text-align left
				font-size 14px
				line-height 22px
				padding: 0 40px
				&:last-child {
					margin-bottom 30px
				}
			}
		}
	}
}
</style>
